import { flatten } from 'lodash';
import { MenuItem } from '../interfaces/Menu/MenuItem';

export const findMenuItemInTree = (
  tree: MenuItem[],
  id: number,
): MenuItem | undefined => {
  const foundInRoot = tree.find((item) => item.id === id);
  if (foundInRoot) {
    return foundInRoot;
  }

  return tree.reduce(
    (acc, item) => acc ?? findMenuItemInTree(item.children, id),
    undefined as MenuItem | undefined,
  );
};

export const getAllMenuItemIDs = (menuItems: MenuItem[]): number[] =>
  flatten([
    menuItems.map((menuItem) => menuItem.id),
    ...menuItems.map((menuItem) => getAllMenuItemIDs(menuItem.children)),
  ]);
